module.exports = __webpack_public_path__ + "img/app-item-uploaded.0d76de18.svg";